var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "SynastryMain" }, [
    _c(
      "div",
      { staticClass: "SynastryMain__interpret" },
      [
        _c("div", { staticClass: "teacherSay" }, [
          _vm._m(0),
          _c("div", { staticClass: "teacherSay__content" }, [
            _vm._m(1),
            _c("div", {
              staticClass: "teacherSay__content__article",
              domProps: { innerHTML: _vm._s(_vm.Paragraph) }
            })
          ])
        ]),
        _c("SynastryInterpret", {
          attrs: { interpretations: _vm.interpretations }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "SynastryMain__content" },
      [
        _c("ScoreStep", {
          attrs: {
            target1: _vm.target1,
            target2: _vm.target2,
            resonance: _vm.resonance
          }
        }),
        _vm.Data1
          ? _c("div", { staticClass: "astrolabeDBL" }, [
              _c("div", { staticClass: "astrolabeDBL__wrap" }, [
                _c(
                  "div",
                  { staticClass: "swiper" },
                  [
                    _c(
                      "swiper",
                      { attrs: { id: "SW", options: _vm.swiperAstrolabe } },
                      _vm._l(_vm.style, function(item) {
                        return _c(
                          "swiper-slide",
                          { key: item.id, staticClass: "astrolabeDBL__item" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "astrolabeDBL__bg",
                                attrs: { id: "astrolabeDBL__bg" }
                              },
                              [
                                _vm.dataChange
                                  ? _c("canvasAstrolabe", {
                                      staticClass: "canvas-pan",
                                      attrs: {
                                        width: _vm.paramPan.width,
                                        configItem: _vm.panConfigItem,
                                        panStyle: item.name,
                                        type: _vm.paramPan.type,
                                        data1: _vm.Data1.AstralRadians,
                                        data2: _vm.Data2
                                          ? _vm.Data2.AstralRadians
                                          : null,
                                        Ret1: _vm.Data1.RetAstralSet,
                                        role: "DBL"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      1
                    ),
                    _vm.style.length > 1
                      ? _c("div", { staticClass: "switch" }, [
                          _c("div", {
                            staticClass: "swiper-button-prev",
                            attrs: { slot: "button-prev" },
                            slot: "button-prev"
                          }),
                          _c("div", {
                            staticClass: "swiper-pagination",
                            attrs: { slot: "pagination" },
                            slot: "pagination"
                          }),
                          _c("div", {
                            staticClass: "swiper-button-next",
                            attrs: { slot: "button-next" },
                            slot: "button-next"
                          })
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _c(
                "div",
                {
                  staticClass: "astrolabeDBL__setting",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.openSetup()
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/icon_setting.svg"),
                      alt: ""
                    }
                  })
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "astrolabeDBL__changeDBL",
                  on: { click: _vm.toListDBL }
                },
                [
                  _vm._m(2),
                  _c("div", { staticClass: "astrolabeDBL__changeDBL__text" }, [
                    _vm._v("切换合盘")
                  ])
                ]
              )
            ])
          : _vm._e(),
        _c("SetAstrolabe", {
          attrs: {
            role: "DBL",
            activeSetup: _vm.activeSetup,
            showDiffType: true
          },
          on: {
            close: function($event) {
              _vm.activeSetup = false
            },
            refreshData: _vm.refreshData
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "teacherSay__header" }, [
      _c("div", { staticClass: "teacherSay__header__pic" }, [
        _c("img", {
          attrs: { src: require("../../../cn-demo-assets//Logo.png"), alt: "" }
        })
      ]),
      _c("div", { staticClass: "teacherSay__header__title" }, [
        _vm._v("星学会给你们的一段话")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "teacherSay__content__subtitle" }, [
      _c("div", { staticClass: "teacherSay__content__subtitle__line" }),
      _c("div", { staticClass: "teacherSay__content__subtitle__text" }, [
        _vm._v("\n            Relationship Insights\n          ")
      ]),
      _c("div", { staticClass: "teacherSay__content__subtitle__line" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "astrolabeDBL__changeDBL__ipc" }, [
      _c("img", {
        attrs: { src: require("@/assets/雙人合盤/changeDBL.svg"), alt: "" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }